(ns ycweb.app.website.myaccount.common
  (:require
   [ycweb.components.flow :as flow]
   [rum.core :as rum]
   [clojure.set :as set]
   #?@(:clj
       [[orchestration.servicedef :as s]
        [macaron.mysql :as mysql]
        [db.all :as db]
        [bernie.core :as bernie]
        [util.core :as uc]
        [api.pos.dashboard.orders :as dashboard-orders]
        [api.products :as products]
        [api.cloudinary.upload :as cloudinary]])
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.components.common :as cmn]
   [ycweb.util.core :as u]
   [ycweb.util.date :as ud]
   [cemerick.url :as url]
   [util.string :as str]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.forms :as input-forms]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.headings :as headings]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.website :as website]
   [ycweb.app.website.header.header :as header]
   [ycweb.components.scroll :as scroll]
   [ycweb.util.urlstate :as urlstate]
   [api.products.helpers :as helpers])

  #?(:clj
     (:import
      (java.lang Math))))

(defn current-user [app-atom]
  (cmn/curact app-atom [:user]))

(rum/defc user-block < rum/reactive [app-atom]
  (let [user (current-user app-atom)
        user-details
        {:user/avatar-letter (:avatarletter user)
         :user/avatar-colour (:avatarcolour user)
         :user/public-id (:public-id user)}]
    [:aside.user-block-wrapper
     [:div.user-block.ie-group
      [:figure.user-block__image-wrapper
       (web-common/user-avatar user-details
         {:width 50 :height 50})]
      [:div.user-block__info
       (headings/heading (u/glue " " (:firstname user) (:lastname user)) {:type :h1 :size :small :flush true :class "user-block__name"})
       [:p.user-block__email (:email user)]

       (when (:supplier-user? user)
         [:div.u-margin-top-10
          [:a.button
           {:class (u/bem :button [:raised :small :primary])
            :href "/supplier-dashboard.htm"}
           [:span.button__text "Supplier Dashboard"]]])]]]))

(rum/defc navbar < rum/reactive [app-atom]
  (let [user (current-user app-atom)
        screen (cmn/curact app-atom [:page :screen])
        {:keys [school]} (rum/react (cmn/action-cursor app-atom))
        has-school-access? (or (not-empty (:school-membership school))
                             (not-empty (:school-courses school)))]
    [:nav.button-bar-wrapper.group {:role "navigation" :aria-label "My Account Menu"}
     [:ul.button-bar.group.js-button-nav.l_tinynav1 {:role "menubar"}
      [:li
       {:class (u/bem :button-bar__item [(when (= screen :web.myaccount) "active")])
        :role "menuitem"}
       [:a.button-bar__link
        (urlstate/href-props app-atom "myaccount") "Dashboard"]]
      [:li
       {:class
        (u/bem :button-bar__item
          [(when (#{:web.myaccount/accountsettings :web.myaccount/addressbook :web.myaccount/newsletters} screen) "active")])
        :role "menuitem"}
       [:a.button-bar__link
        (urlstate/href-props app-atom "myaccount" "accountsettings")
        "Account" [:span.clip-text.clip-text--t.unclip-text--l " Settings"]
        [:i {:class (u/bem :icon [:chevron-down :is-dark :inline])}]]
       [:ul.button-bar__sub-menu
        [:li.button-bar__sub-menu-item [:a.button-bar__sub-menu-link
                                        (urlstate/href-props app-atom "myaccount" "accountsettings")
                                        "Profile"]]
        [:li.button-bar__sub-menu-item [:a.button-bar__sub-menu-link
                                        (urlstate/href-props app-atom "myaccount" "addressbook")
                                        "Addresses"]]
        [:li.button-bar__sub-menu-item [:a.button-bar__sub-menu-link
                                        (urlstate/href-props app-atom "myaccount" "newsletters")
                                        "Newsletters"]]]]
      [:li
       {:class (u/bem :button-bar__item [(when (= screen :web.myaccount/orders) "active")])
        :role "menuitem"}
       [:a.button-bar__link
        (urlstate/href-props app-atom "myaccount" "orders")
        "Orders"]]
      [:li
       {:class (u/bem :button-bar__item [(when (= screen :web.myaccount/aftersales) "active")])
        :role "menuitem"}
       [:a.button-bar__link
        (urlstate/href-props app-atom "myaccount" "aftersales")
        "Returns & Repairs"]]
      [:li
       {:class (u/bem :button-bar__item [(when (= screen :web.myaccount/reviews) "active")])
        :role "menuitem"}
       [:a.button-bar__link
        (urlstate/href-props app-atom "myaccount" "reviews")
        #_{:href "/myaccount.htm?action=reviews"}
        "Reviews"]]
      [:li
       {:class (u/bem :button-bar__item [(when (= screen :web.myaccount/wishlist) "active")])
        :role "menuitem"}
       [:a.button-bar__link
        (urlstate/href-props app-atom "myaccount" "wishlist")
        "Wish List"]]
      [:li
       {:class (u/bem :button-bar__item [(when (= screen :web.myaccount/registry) "active")])
        :role "menuitem"}
       [:a.button-bar__link
        (urlstate/href-props app-atom "myaccount" "registry")
        "Registries"]]
      (when has-school-access?
        [:li
         {:class (u/bem :button-bar__item [(when (= screen :web.myaccount/school) "active")])
          :role "menuitem"}
         [:a.button-bar__link
          (urlstate/href-props app-atom "myaccount" "school")
          "Cooking School"]])
      (when (:supplier-user? user)
        [:li.button-bar__item
         {:role "menuitem"}
         [:a.button-bar__link
          {:href "/supplier-dashboard.htm"}
          "Suppliers"]])]

     [:div.form.button-bar-select
      [:div.yc-select-wrapper
       [:select#tinynav1.tinynav.select
        {:on-change
         (fn [e]
           (let [action (u/presence (.. e -target -value))]
             (urlstate/redirect app-atom "myaccount" action)))
         :value (if (= screen :web.myaccount) "" (u/safe-name screen))}
        [:option {:disabled true} "Navigation"]
        [:option {:value ""} "Dashboard"]
        [:option {:value "accountsettings"} "Account Settings"]
        [:option {:value "accountsettings"} "- Profile"]
        [:option {:value "addressbook"} "- Addresses"]
        [:option {:value "newsletters"} "- Newsletters"]
        [:option {:value "orders"} "Orders"]
        [:option {:value "aftersales"} "Returns & Repairs"]
        [:option {:value "reviews"} "Reviews"]
        [:option {:value "wishlist"} "Wish List"]
        [:option {:value "registry"} "Registries"]
        (when has-school-access?
          [:option {:value "school"} "Cooking School"])]]]]))

(rum/defc screen-wrapper < rum/reactive [app-atom component]
    ;; Fetch school data on initial load to populate navbar
  (comms/ajax-get :web.myaccount/school {})
  (website/screen-wrapper app-atom
    [:div
     [:main {:id "main-content" :class (u/bem :yc-page-content [:standard])}
      (user-block app-atom)

      (navbar app-atom)

      component]]
    {}))